export const CANCELLED_ALERT_MSG = 'Your transaction has been cancelled. Please enter valid payment details to try again.'
export const ACCOUNT_PICKER_CANCELLED_ALERT_MSG = 'You have cancelled the account verification process.';
export const ACCOUNT_PICKER_ERROR_ALERT_MSG = 'An error has occurred while verifying your bank account. Please try again with a different bank account.';
export const DEFAULT_ALERT_MSG = 'Payment Error';
